import { z } from 'zod';
import type { TFunction } from 'i18next';

export function createProfileSchema(t: TFunction) {
  return z.object({
    firstName: z
      .string()
      .min(1, t('validation.firstName_required')),
    lastName: z
      .string()
      .min(1, t('validation.lastName_required')),
    phone: z
      .string()
      .optional(),
    company: z
      .string()
      .optional(),
  });
}

export type ProfileFormValues = z.infer<ReturnType<typeof createProfileSchema>>;
